import React from 'react';
import { string } from 'prop-types';
import classNames from 'classnames';

import { intlShape } from '../../util/reactIntl';
import { propTypes } from '../../util/types';
import * as validators from '../../util/validators';
import { FieldSelect } from '../../components';
import { PHONE_CODES } from '../../util/maps';

import css from './AuthenticationPage.module.css';

const UserFieldPhoneCode = props => {
  const { rootClassName, className, formId, formName, intl } = props;

  const validateMaybe = {
      validate: validators.required('Debes seleccionar un código de país'),
    };

  return (
    <>
      <FieldSelect
        className={classNames(className, css.flagsDesktop, { [rootClassName]: !!rootClassName })}
        type="text"
        id={formId ? `${formId}.phoneCode` : 'phoneCode'}
        name="phoneCode"
        label="Clave"
        {...validateMaybe}
      >
        <option value="">Seleccione un código de pais</option>
        {PHONE_CODES.map(code => {
          return <option value={code.value} key={code.country}>{code.country} ({code.value})</option>
        })}
      </FieldSelect>
      <FieldSelect
        className={classNames(className, css.flagsMobile, { [rootClassName]: !!rootClassName })}
        type="text"
        id={formId ? `${formId}.phoneCode` : 'phoneCode'}
        name="phoneCode"
        label="Clave"
        {...validateMaybe}
      >
        <option value="">Seleccione un código de pais</option>
        {PHONE_CODES.map(code => {
          return <option value={code.value} key={code.country}>{code.flag} {code.name} ({code.value})</option>
        })}
      </FieldSelect>
    </>
  );
};

UserFieldPhoneCode.defaultProps = {
  rootClassName: null,
  className: null,
  formId: null,
};

UserFieldPhoneCode.propTypes = {
  rootClassName: string,
  className: string,
  formId: string,
  formName: string,
  intl: intlShape,
};

export default UserFieldPhoneCode;
